import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        ...state
    }
}

const ModalMessageComponent = (props) => {
    console.log(props);
    const  showModal  = props.quoteStart.sessionTimeOut;
    console.log(showModal);

    const reloadWindow = () => {
        window.location.reload();
    }

    const style = {
        display: showModal ? 'block' : 'none'
        //display: 'block'
    };

    const overlayStyle = {
        ...style,
        position: 'fixed',
        height: '100%',
        width: '100%',
        background: 'rgba(2, 2, 2, 0.64)',
        top: '0em',
        left: 0,
        zIndex: 50
    }
    //LoadingReducer.showModal
    return (
        <div style={overlayStyle} className="overlay">
            <div className="modal" style={overlayStyle} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="loading-message">
                                <h1>Sorry</h1>
                                <p>You're session has timed out.</p>
                                <p><small>Tokens last for 1 hour</small></p>
                                <button 
                                    onClick={reloadWindow}
                                    className="btn btn-success">
                                    Start a new quote
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(ModalMessageComponent);


// WEBPACK FOOTER //
// ./src/ModalMessage/index.js